import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import BatteryInfo from './MessageDetails/BatteryInfo.vue';
import VoltageRecord from './MessageDetails/VoltageRecord.vue';
import ChargingRecord from './MessageDetails/ChargingRecord.vue';
import { domainName } from "../../../utility/index"

export default {
    name: "BatteryStatus",
    components: { tree, iTable, IPagination, BatteryInfo, VoltageRecord, ChargingRecord },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                carId: '',
                batteryNumber: '',
                terminalId: '',
                batteryState: '',
                batteryWarning: '',
            },
            stateList: [
                { id: '', name: this.$t('common.all') },
                { id: '0', name: this.$t('BatteryStatus.leisure') },
                { id: '1', name: this.$t('BatteryStatus.charge') },
                { id: '2', name: this.$t('BatteryStatus.work') },
            ],
            warnList: [
                { id: '', name: this.$t('common.all') },
                { id: '0', name: this.$t('common.normal') },
                { id: '1', name: this.$t('common.abnormal') },
            ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "batteryNumber",
                    label: this.$t('BatteryFile.batteryNumber'),
                    align: "center",
                    width: '140'
                },
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: '140'
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: '160'
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: '100'
                },
                {
                    prop: 'batteryType',
                    label: this.$t('BatteryFile.batteryType'),
                    align: 'center',
                    fixed: 'right',
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.batteryType == '' ? '' : params.row.batteryType == 1 ? this.$t('BatteryFile.plumbicAcid') : this.$t('BatteryFile.lithium') }
                        }, params.row.batteryType == '' ? '' : params.row.batteryType == 1 ? this.$t('BatteryFile.plumbicAcid') : this.$t('BatteryFile.lithium'))
                    }
                },
                {
                    prop: "batteryElectricity",
                    label: this.$t('BatteryStatus.batteryElectricity'),
                    align: "center",

                },
                {
                    prop: "batteryPower",
                    label: this.$t('BatteryStatus.voltage'),
                    align: "center",

                },
                {
                    prop: "messageTime",
                    label: this.$t('common.messageTime'),
                    align: "center",
                    width: "160",
                    // render: (h, params) => {
                    //     return h('span', this.$formatTime(params.row.messageTime))
                    // }
                },


                {
                    prop: 'batteryState',
                    label: this.$t('BatteryStatus.batteryState'),
                    align: 'center',
                    fixed: 'right',
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.batteryState == null ? '' : params.row.batteryState == 0 ? 'danger' : params.row.batteryState == 1 ? 'success' : 'primary' }
                        }, params.row.batteryState == null ? '' : params.row.batteryState == 0 ? this.$t('BatteryStatus.leisure') : params.row.batteryState == 1 ? this.$t('BatteryStatus.charge') : this.$t('BatteryStatus.work'))
                    }
                },
                {
                    prop: 'batteryWarning',
                    label: this.$t('BatteryStatus.isWarning'),
                    align: 'center',
                    fixed: 'right',
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.batteryWarning == null ? '' : params.row.batteryWarning == 0 ? 'success' : 'danger' }
                        }, params.row.batteryWarning == null ? '' : params.row.batteryWarning == 0 ? this.$t('common.normal') : this.$t('common.abnormal'))
                    }
                }
            ],
            dialogFormVisible: false,
            activeName: 'first',
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.dialogFormVisible = true
                            this.queryDetails(index, row)
                        }
                    }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            terminalId: '',
            batteryNumber: '',
            driverNum: ''
        }
    },
    created() {
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        queryDetails(index, row) {
            this.batteryNumber = row.batteryNumber
            this.carId = row.carId
            this.driverNum = row.driverNum
            this.$nextTick(() => {
                this.activeName = 'first'
                this.$refs.batteryInfo.getSelectOneTerminal()
            })
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            if (this.$route.params.carId) {
                this.formInline.carId = this.$route.params.carId
            }
            if (this.$route.params.batteryId) {
                this.formInline.batteryState = this.$route.params.batteryId
            }
            this.getBatteryStatus()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getBatteryStatus()
        },
        getBatteryStatus() {
            let param = {
                orgId: this.id,
                carId: this.formInline.carId,
                batteryNumber: this.formInline.batteryNumber,
                terminalId: this.formInline.terminalId,
                batteryState: this.formInline.batteryState,
                batteryWarning: this.formInline.batteryWarning,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            console.log(param)
            this.$store.dispatch('BatteryFile/GET_QUERYBATTERYSTATUSPAGE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getBatteryStatus()
        },
        onClear() {
            this.formInline = {
                carId: '',
                batteryNumber: '',
                terminalId: '',
                batteryState: '',
                batteryWarning: '',
            }
            this.getBatteryStatus()
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/uploadBatteryStatus?orgId=${this.id}&carId=${this.formInline.carId}&batteryNumber=${this.formInline.batteryNumber}&terminalId=${this.formInline.terminalId}&batteryState=${this.formInline.batteryState}&batteryWarning=${this.formInline.batteryWarning}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/uploadBatteryStatus?orgId=${this.id}&carId=${this.formInline.carId}&batteryNumber=${this.formInline.batteryNumber}&terminalId=${this.formInline.terminalId}&batteryState=${this.formInline.batteryState}&batteryWarning=${this.formInline.batteryWarning}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getBatteryStatus();
        },
        handleClick(event) {
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$nextTick(() => {
                    this.$refs.batteryInfo.getSelectOneTerminal()
                })
            } else if (this.activeName == 'second') {
                this.$nextTick(() => {
                    this.$refs.chargingRecord.getCarRealTime()
                })
            } else if (this.activeName == 'third') {
                this.$nextTick(() => {
                    this.$refs.voltageRecord.getSpeedAndWeightHis()
                })
            }
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}